// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"c1989ca5","110":"9c0cac90","528":"6476a964","684":"04746e02","792":"10713ddd"}[chunkId] + ".chunk.js";
};